import { Column, Row } from 'react-table';
import { createWorkbook, ExcelWorkbook } from '@fluentsms/utils';
import { toWorksheet } from './toWorksheet';

export function toWorkbook<TRow extends Record<string, unknown>>(props: {
  rows: Row<TRow>[];
  visibleColumns: Column<TRow>[];
  prepareRow: (row: Row<TRow>) => void;
  selectedRowIds: Record<string, boolean>;
  sheetName: string;
}): ExcelWorkbook {
  const { rows, prepareRow, visibleColumns, sheetName, selectedRowIds } = props;

  return createWorkbook({
    orderedSheets: [
      toWorksheet({
        name: sheetName,
        rows,
        visibleColumns,
        prepareRow,
        selectedRowIds,
      }),
    ],
  });
}
